import submitCommand from '../../../services/submitCommand';
import { CourseStep } from '../models/course';

export const editLinkUrl = (
  courseId: string,
  taskId: string,
  linkUrl: string,
  stepName: string,
  order: number,
  initiatingUserId: string
): Promise<CourseStep> => {
  return submitCommand(
    courseId,
    {
      id: courseId,
      taskId: taskId,
      linkUrl: linkUrl,
      initiatingUserId: initiatingUserId,
    },
    'SetLinkUrl',
    'LinkUrlSetForLinkTask',
    'TaskListError'
  ).then(() => ({
    _id: { id: taskId },
    _type: 'Link',
    taskName: stepName,
    order,
  }));
};
